export class UserSession {
    userId: number;
    userFullName: string;
    subuser_type: string;
    roleId: number;
    authToken: string;
    roleName: string;
    email: string;
    mobileNumber: string;
    languageType: number;
    isDynamicPassword: boolean;
    role: any = [];
    districtId: number;
    userEmail:string;
    statusId: number;
    usermobile:string;
    isFirstLogin: any;
    subUserApplicant: string;
    isagenable: number;
    is192aexist: number;
    isTANMANG: number;
    isWbSubUser: boolean;
    isWbApplicant: boolean;
    
}
